module.exports = __webpack_public_path__ + "static/media/Udemy_logo.bd18d6ff.png";